import { useCallback, useState } from "react"

import { useNavigate, useParams } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { FilterBottomSheet } from "@l2r-front/l2r-ui"
import { useUrlParams } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { HorizontalSignsSidebarComponents } from "../../components/HorizontalSignsSidebarComponents"
import { HORIZONTAL_SIGNING_CONDITION_URL_PARAM, HORIZONTAL_SIGNING_CODE_URL_PARAM } from "../../constants/urlParams"
import { useGetHorizontalSignTypeCatalogUtils } from "../../hooks/utils/useGetHorizontalSignTypeCatalogUtils"

import { HorizontalSignFilters } from "../HorizontalSignFilters"

import * as Styled from "./HorizontalSigningMobileContent.styled"

export const HorizontalSigningMobileContent = () => {
    const { getHorizontalSignTypeDepth, getHorizontalSignTypeChildren } = useGetHorizontalSignTypeCatalogUtils()
    const navigate = useNavigate()
    const { getParam } = useUrlParams()
    const [displayFilters, setDisplayFilters] = useState(false)
    const closeFilters = () => setDisplayFilters(false)
    const { road } = useParams()
    const { t } = useTranslation(I18N_NAMESPACE)

    const handleChangeTypeFilter = useCallback((filters) => {
        const filterCodeDepth = getHorizontalSignTypeDepth(filters.type)
        const children = getHorizontalSignTypeChildren(filters.type)
        if (filterCodeDepth % 2 === 1 && children.length > 1) {
            const condition = getParam(HORIZONTAL_SIGNING_CONDITION_URL_PARAM)
            navigate(`./code/${filters.type}?${HORIZONTAL_SIGNING_CODE_URL_PARAM}=${filters.type}${condition ? `&${HORIZONTAL_SIGNING_CONDITION_URL_PARAM}=${condition}` : ""}`)
        }
    }, [getParam, getHorizontalSignTypeDepth, getHorizontalSignTypeChildren, navigate])

    const navigateBack = useCallback(() => {
        return navigate("../")
    }, [navigate])

    return (
        <Styled.BottomSheetContent id="horizontalSignDetails-sidebar"
            onBack={road ? navigateBack : null}
            title={t(I18N_NAMESPACE, `containers.horizontalSigningSidebar.${road ? "roadTitle" : "title"}`)}
        >
            <HorizontalSignsSidebarComponents handleChangeTypeFilter={handleChangeTypeFilter} />
            <FilterBottomSheet open={displayFilters} onClose={closeFilters}>
                <HorizontalSignFilters displayFilters={displayFilters} close={closeFilters} />
            </FilterBottomSheet>
        </Styled.BottomSheetContent>
    )
}